namespace Ir.Components.Workbook.Settings.WidgetGeneralSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<DashboardWidget>;
        itemConfig: BaseItemConfig;
        widgetType: WidgetType;
        appearance: AppearanceConfig;
        layout: LayoutConfig;
        onWidgetChangedTop: (e) => void;
        onWidgetChangedLeft: (e) => void;
        onWidgetChangedWidth: (e) => void;
        onWidgetChangedHeight: (e) => void;
        tabDetailParams: Ir.Components.Workbook.Settings.Items.TabDetailSetting.ITabDetailSettingParams;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;
        
        self.config = params.config as WorkbookConfig;
        self.activeTabOrWidget = params.activeTabOrWidget;
        
        self.onWidgetChangedTop = function (e) {
            let dashboard = self.activeTabOrWidget().dashboard;
            let layout = self.activeTabOrWidget().manualLayout;
            if (e.value === null || e.value < 0) {
                layout.top(0);
                DevExpress.ui.notify("You have reached the minimum top.", "warning");
            }
            else {
                if (e.value + layout.height() > dashboard.maxHeight) {
                    layout.top(dashboard.maxHeight - layout.height());
                    DevExpress.ui.notify("You have reached the top limit.", "warning");
                }
            }
        };
        self.onWidgetChangedLeft = function (e) {
            let dashboard = self.activeTabOrWidget().dashboard;
            let layout = self.activeTabOrWidget().manualLayout;
            if (e.value === null || e.value < 0) {
                layout.left(0);
                DevExpress.ui.notify("You have reached the minimum left.", "warning");
            }
            else {
                if (e.value + layout.width() > dashboard.maxWidth) {
                    layout.left(dashboard.maxWidth - layout.width());
                    DevExpress.ui.notify("You have reached the left limit.", "warning");
                }
            }
        };
        self.onWidgetChangedWidth = function (e) {
            let dashboard = self.activeTabOrWidget().dashboard;
            let layout = self.activeTabOrWidget().manualLayout;
            if (e.value < 20) {
                layout.width(20);
                DevExpress.ui.notify("You have reached the minimum width.", "warning");
            }
            else {
                if (layout.left() + e.value > dashboard.maxWidth) {
                    layout.width(dashboard.maxWidth - layout.left());
                    DevExpress.ui.notify("You have reached the width limit.", "warning");
                }
            }
        };
        self.onWidgetChangedHeight = function (e) {
            let dashboard = self.activeTabOrWidget().dashboard;
            let layout = self.activeTabOrWidget().manualLayout;
            if (e.value < 20) {
                layout.height(20);
                DevExpress.ui.notify("You have reached the minimum height.", "warning");
            }
            else {
                if (layout.top() + e.value > dashboard.maxHeight) {
                    layout.height(dashboard.maxHeight - layout.top());
                    DevExpress.ui.notify("You have reached the height limit.", "warning");
                }
            }
        };

        self.tabDetailParams = {
            tab: ko.pureComputed({
                read: function () {
                    return self.activeTabOrWidget().tabDetailId ? self.activeTabOrWidget().tabDetailId() : 0;
                },
                write: function (value) {
                    if (self.activeTabOrWidget().tabDetailId) {
                        self.activeTabOrWidget().tabDetailId(value);
                    }
                },
            }),
        };
    }
}